import { Upload } from "@mui/icons-material";
import { Alert, Box, Chip, CircularProgress, Grid } from "@mui/material";
import React, { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import style from "./styles";
import Button from "../Button/Bouton";

interface Props {
  onChange(file?: File): void;
  name: string;
  label?: string;
  disabled?: boolean;
  subtitle?: string;
  maxFiles?: number;
  isFetching?: boolean;
  errors?: any;
  value?: File;
}

const useForceUpdate = () => {
  const [value, setValue] = React.useState(false);
  return () => setValue(!value);
};
function InputFileDragDrop(props: Props) {
  const {
    onChange,
    name,
    label,
    disabled,
    subtitle,
    maxFiles,
    isFetching,
    errors,
    value,
  } = props;
  const forceUpdate = useForceUpdate();

  const [error, setError] = useState<string | undefined>();
  const handleChangeFile = (file: File) => {
    setError(undefined);

    onChange(file);
    forceUpdate();
  };

  const handleSizeError = () => {
    onChange(undefined);
    setError("La taille de votre fichier est trop volumineuse");
  };

  const handleTypeError = () => {
    onChange(undefined);
    setError("Ce format de fichier n'est pas autorisé");
  };

  const downloadFile = () => {
    const f = value;
    const file = f && new Blob([f]);
    if (file && f) {
      // const fileURL = URL.createObjectURL(file);
      // window.open(fileURL);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(file);
      link.download = f.name;
      link.click();
    }
  };
  return (
    <Box sx={style}>
      <div className="document-container">
        <FileUploader
          handleChange={handleChangeFile}
          name={name}
          onSizeError={handleSizeError}
          onTypeError={handleTypeError}
          on
          maxSize={10}
          value={value}
          components
          types={["jpeg", "jpg", "png", "pdf"]}
        >
          <div className="document-btnadd">
            {/* <p> {t('addDocument')}</p>
            <span>ou</span> */}
            <Button
              variant="contained"
              color="secondary"
              label={"Ajouter ou glisser un fichier"}
              icon={<Upload />}
            />
          </div>
        </FileUploader>
        {isFetching && <CircularProgress size={30} />}
      </div>

      {value && (
        <Grid container sx={{ mt: 1 }} justifyContent="center">
          <Chip
            label={value.name}
            className="filename"
            onDelete={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onChange(undefined);
            }}
            clickable
            onClick={downloadFile}
          ></Chip>
        </Grid>
      )}
      <span className="document-subtitle">
        Taille max : 10Mo - Format attendu : PNG, JPEG, PDF
      </span>
      {error && (
        <Alert severity="error" sx={{ mt: 1, fontSize: 13 }}>
          {error}
        </Alert>
      )}
      {errors && (
        <Alert severity="error" sx={{ mt: 1, fontSize: 13 }}>
          {errors.response?.data?.description ||
            errors.response?.data?.message ||
            "Une erreur est survenue"}
        </Alert>
      )}
    </Box>
  );
}

export default InputFileDragDrop;
